import { QuillEditor, Quill, Delta } from "@vueup/vue-quill";

// @ts-ignore
import toPlaintext from "quill-delta-to-plaintext";

export const useConvertQuillToPlaintext = (ops: any, trim: boolean = true) => {
  if (!ops) return "";

  var delta = new Delta(ops);
  var comment = toPlaintext(delta);

  if (trim) {
    return comment.trim();
  }

  return comment;
};